import { App } from '../AppManager';

interface RobotsGeneratorOptions {
  appData: App;
  customDomain?: string;
}

export const generateRobots = ({ appData, customDomain }: RobotsGeneratorOptions): string => {
  // Get the primary domain (custom domain or Firebase domain)
  const primaryDomain = customDomain || `${appData.id}.web.app`;
  const sitemapUrl = `https://${primaryDomain}/sitemap.xml`;
  
  const robotsContent = `User-agent: *
Allow: /

# Sitemap
Sitemap: ${sitemapUrl}

# Block access to admin areas
Disallow: /admin/
Disallow: /api/
Disallow: /.well-known/

# Allow common files
Allow: /favicon.ico
Allow: /robots.txt
Allow: /manifest.json
Allow: /sitemap.xml

# Powered by Dine Platform
# Visit https://www.dineplatform.com for more information
`;

  return robotsContent;
};

export const generateRobotsFile = (options: RobotsGeneratorOptions): { content: string; filename: string } => {
  const content = generateRobots(options);
  const filename = 'robots.txt';
  
  return {
    content,
    filename
  };
};